import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GoogleAnalyticsService {
  constructor() {}

  public sendGAEvent(eventName: string,options:any){
    /* 
      Note: options should be a JSON containing required parameters as key value pair
      Ex: {current_user_id: "abcd1234"}
      eventName -> Any Name of Event, Ex: (login, admin-login, share-project etc)
    */
   
    gtag('event', eventName, options)
  }
}
